const PREFIX = 'conversations_client';

export const METRIC = {
  start_conversation_success: `${PREFIX}.start_conversation.success`,
  start_conversation_error: `${PREFIX}.start_conversation.error`,
  send_feedback_success: `${PREFIX}.send_feedback.success`,
  send_feedback_error: `${PREFIX}.send_feedback.error`,
  send_message_success: `${PREFIX}.send_message.success`,
  send_message_error: `${PREFIX}.send_message.error`,
  action_success: `${PREFIX}.action.success`,
  action_error: `${PREFIX}.action.error`,
  request_action_success: `${PREFIX}.request_action.success`,
  request_action_error: `${PREFIX}.request_action.error`,

  fetch_messages_duration: `${PREFIX}.fetch_messages.duration`,
  fetch_participants_duration: `${PREFIX}.fetch_participants.duration`,

  // should this be distinct from action_error?
  action_not_supported: `${PREFIX}.action.not_supported`,

  // these may be potentially better suited to only error reporting
  update_messages_error: `${PREFIX}.update_messages.error`,
  fetch_messages_error: `${PREFIX}.fetch_messages.error`,
  fetch_participants_error: `${PREFIX}.fetch_participants.error`,
  log_missing_message: `${PREFIX}.log_missing_message`,
};
